import { useState } from 'react'
import { useDispatch } from 'react-redux'

import { Box, Button, LinearProgress, Link, Typography } from '@material-ui/core'
import { SpeakerField } from 'UI/Routes/quick-guidde/QGSidePanel/VoiceOverPanel/TextToSpeech/SpeakerField'
import { ReactComponent as RollNext } from 'assets/icons/roll-next.svg'

import { AudioConfigsType, PlaybookType, SpeakerType } from 'app/types'
import { useDataMutation, useQuery } from 'hooks'
import { setAudioConfigs } from 'ducks'
import { logToAnalytics, playbookToAnalyticsProps } from 'modules'

type Props = {
    playbook: PlaybookType
    onDone: () => void
    onClose: () => void
}

export const Convert = ({ playbook, onDone, onClose }: Props) => {
    const dispatch = useDispatch()

    const [speakerConfig, setSpeakerConfig] = useState<null | SpeakerType>(null)

    useQuery<AudioConfigsType>(
        `/c/v1/config/qg/audio`,
        {
            method: 'GET'
        },
        {
            onSuccess: data => dispatch(setAudioConfigs(data)),
            revalidateOnFocus: false
        }
    )

    const $convertT2s = useDataMutation<
        { playbookId: string; config: SpeakerType },
        unknown,
        Error
    >('/c/v1/quickguidde/convertT2s', 'POST')

    return (
        <Box width="100%">
            {$convertT2s.isLoading && <LinearProgress />}

            <Box p={2}>
                <Typography>
                    <b>
                        Generate natural sounding voiceovers <br /> from the step descriptions
                    </b>
                </Typography>

                <Box my={2}>
                    <Typography>01. Review the descriptions.</Typography>
                    <Typography>02. Choose speaker.</Typography>
                    <Typography>03. Generate!</Typography>
                </Box>

                <Box mb={3} mr={7} p={1} bgcolor="#F5F5F5" borderRadius={4}>
                    <SpeakerField
                        languageCode={playbook?.magicCapture?.language?.langCode || 'en-US'}
                        currentSpeaker={speakerConfig}
                        onSelect={setSpeakerConfig}
                    />
                </Box>

                <Button
                    disabled={$convertT2s.isLoading}
                    startIcon={<RollNext />}
                    onClick={() => {
                        if (!speakerConfig) return

                        logToAnalytics('magic_capture_converted', {
                            ...playbookToAnalyticsProps(playbook)
                        })

                        $convertT2s
                            .mutate({ playbookId: playbook.id, config: speakerConfig })
                            .then(onDone)
                            .then(onClose)
                    }}
                >
                    GENERATE
                </Button>

                <Box mt={1}>
                    <Link
                        style={{ color: '#2D9CDB' }}
                        component="button"
                        variant="body1"
                        color="secondary"
                        underline="always"
                        onClick={() => {
                            logToAnalytics('magic_capture_ignored', {
                                ...playbookToAnalyticsProps(playbook)
                            })
                            onClose()
                        }}
                    >
                        Ignore
                    </Link>
                </Box>
            </Box>
        </Box>
    )
}
